<template>
  <div :class="{login: !$store.getters.isLoggedIn}">
    <vue-particles
      color="#405E7E"
      class="particles"
      :particlesNumber="25"
      :particleSize="7"
      :lineOpacity="0"
      :particleOpacity="0.4"
      :hoverEffect="false"
      :clickEffect="false"
    />
    <div class="page">
      <v-container>
        <v-row
          justify="end"
          style="padding: 0px 20px"
        >
          <SwitchLang color="#fff" />
        </v-row>
        <div
          class="d-flex justify-center"
        >
          <v-img
            class="logo"
            src="@/assets/images/aquassist_reverse.png"
            alt="Aquassist"
          />
        </div>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="9"
            md="6"
            lg="4"
            xl="3"
          >
            <slot name="content" />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="footer">
      <div class="mask" />
    </div>
  </div>
</template>

<script>
import SwitchLang from '@/components/shared/SwitchLang';

export default {
    components: {
        SwitchLang,
    },
};
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/vuetify_variables.scss';

  .login {
    width: 100%;
    height: 100%;
    background-color: #26384B;

    .particles {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 6;
    }

    .page {
      position: relative;
      z-index: 10;

      .logo {
        flex: 0 0 400px;
        max-width: 100%;
        margin-top: 100px;
        margin-bottom: 25px;
        @media #{map-get($display-breakpoints, 'xs-only')} {
          margin-top: 25px;
        }
      }
    }

    .footer {
      position: absolute;
      z-index: 5;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 200px;
      background-size: cover;
      background-position: center center;
      background-image: url('~@/assets/images/login_footer_bg.png');

      .mask {
        position: relative;
        width: 100%;
        height: 100%;
        background: rgb(38, 56, 75);
        background: linear-gradient(180deg, rgba(38, 56, 75, 1) 0%, rgba(38, 56, 75, 0) 50%);
      }
    }
    .privacy-policy {
        display: flex;
        justify-content: center;

        margin-top: 380px;
        width: 100%;
        color: white;
        @media #{map-get($display-breakpoints, 'md-and-down')} {
          margin-top: 200px;
        }
    }
  }
</style>
